import { useGetProductCategoriesMutation, useGetEpiProductCategoriesMutation, ProductCategory, EpiProductCategory } from '@services';
import { useEffect, useState } from 'react';

type CategoryType = ProductCategory | EpiProductCategory;

export const useGenericCategoryDisplayer = (type: 'appro' | 'epi') => {
    const [categories, setCategories] = useState<CategoryType[]>([]);
    const [errorMessage, setErrorMessage] = useState<string>('');

    const [getCategories, { data: categoriesData, isLoading, isError }] = useGetProductCategoriesMutation();
    const [getEpiCategories, { data: epiCategoriesData, isLoading: isEpiLoading, isError: isEpiError }] =
        useGetEpiProductCategoriesMutation();

    const toTitleCase = (phrase: string) =>
        phrase
            .toLowerCase()
            .split(' ')
            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');

    useEffect(() => {
        if (type === 'appro') {
            getCategories(undefined);
        } else {
            getEpiCategories(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);

    useEffect(() => {
        if (type === 'appro') {
            if (categoriesData) {
                setCategories(categoriesData);
            }
            if (isError) {
                setErrorMessage('Une erreur est survenue lors du chargement des catégories');
            }
        } else {
            if (epiCategoriesData) {
                setCategories(epiCategoriesData);
            }
            if (isEpiError) {
                setErrorMessage('Une erreur est survenue lors du chargement des catégories EPI');
            }
        }
    }, [categoriesData, epiCategoriesData, isError, isEpiError, type]);

    return {
        categories,
        isLoading: type === 'appro' ? isLoading : isEpiLoading,
        errorMessage,
        toTitleCase
    };
};
